import { render } from "./TheDashBoard.vue?vue&type=template&id=37b88b84"
import script from "./TheDashBoard.vue?vue&type=script&lang=js"
export * from "./TheDashBoard.vue?vue&type=script&lang=js"

import "./TheDashBoard.vue?vue&type=style&index=0&id=37b88b84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__